export enum SmsStatus {
  /**
   * Waiting to be sent to the SMS provider
   * */
  Created = 0,
  /**
   * Sent to the SMS provider
   */
  Pending,
  /**
   * SMS Provider has sent the message
   */
  Sent,
  /**
   * SMS Provider confirmed delivery
   */
  Received,
  /**
   * Message sending has failed.
   */
  Failed = 400,
}

export interface ISmsMessage {
  id: string;
  status: SmsStatus;
  smsQueueItemId: number;
  rideitInvitationId?: string | null;
  smsProviderId: string;
  to: string;
  sentAt?: Date | string | null;
  statusUpdatedAt: Date | string;
  failReason: string;
}

export default class SmsMessage implements ISmsMessage {
  id: string;
  status: SmsStatus;
  smsQueueItemId: number;
  rideitInvitationId?: string | null;
  smsProviderId: string;
  to: string;
  sentAt?: Date | string | null;
  statusUpdatedAt: Date | string;
  failReason: string;

  constructor(options?: ISmsMessage | null) {
    this.id = options?.id ?? "";
    this.status = options?.status ?? SmsStatus.Created;
    this.smsQueueItemId = options?.smsQueueItemId ?? 0;
    this.rideitInvitationId = options?.rideitInvitationId ?? null;
    this.smsProviderId = options?.smsProviderId ?? "";
    this.to = options?.to ?? "";
    this.sentAt = options?.sentAt ?? null;
    this.statusUpdatedAt = options?.statusUpdatedAt ?? new Date().toISOString();
    this.failReason = options?.failReason ?? "";
  }
}
